import { DEFAULT_DATE_FORMAT } from '@iconik-io/core/src/date/date_formats';

import type { AppState } from '../../store/types';

export const selectDateFormat = (state: AppState) => {
  return state.settings.merged.date_format || DEFAULT_DATE_FORMAT;
};
